// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1xvJK","title":"ClientReferral_title__TYn1Z","itemText":"ClientReferral_itemText__3fhiF"};